import { Component, Input} from '@angular/core';
import { FinanceService } from '../../../../services/api/finance.service';
import { HelpersService } from '../../../../services/helpers.service';
import { CompanyContractModel, ContractStepModel, PaymentTransactionModel_Opt } from '../../../../models/contract.model';
import { MatDialogRef } from '@angular/material/dialog';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { of, switchMap } from 'rxjs';
import { ContractDataService } from '../../services/contract-data.service';
import { TPaymentData } from '../../../../models/finance.model';
import { ContractPaymentStatusIconMap } from '../../models/contract-styling-consts';
@Component({
    selector: 'app-contract-step-payment-view',
    templateUrl: './contract-step-payment-view.component.html',
    styleUrl: './contract-step-payment-view.component.scss'
})
export class AppContractStepPaymentViewComponent {
    @Input() paymentGuid: string|null=null;
    @Input() paymentStep: ContractStepModel|null=null;
    @Input() contractParties:CompanyContractModel[] = []
    @Input() paymentInfo: TPaymentData|null=null;
    @Input() targetData:PaymentTransactionModel_Opt|undefined = undefined
    paymentTotal:number|string|undefined = ''
    paymentDetails:{key:string,value:string|null}[]=[]
    paymentError:boolean = false;
    paymentTitleStatus:string=''
    public contractPaymentStatusIconMap = ContractPaymentStatusIconMap
    constructor(
        public dialogRef:MatDialogRef<AppContractStepPaymentViewComponent>,
        public financeService: FinanceService,
        public helpersService: HelpersService,
        public contractDataService: ContractDataService,
        private datePipe: DatePipe,
        private titleCasePipe: TitleCasePipe,
        private translateService:TranslateService
    ) {}

    ngOnInit(): void {

      if (this.paymentGuid) {
        of(this.paymentGuid&&this.paymentStep)
        .pipe(
            switchMap(res=>res? of({transaction:this.paymentStep?.payment_data}) : this.financeService.getPayment(this.paymentGuid!)))
        .subscribe(payment => payment.transaction? this.setPaymentData(payment.transaction) : null)
      } else {
         this.dialogRef.close()
      }
    }
    setPaymentData (paymentInfo:PaymentTransactionModel_Opt|TPaymentData) {
      this.paymentTotal = this.paymentStep?.payment_data?.total;
      
      this.targetData? null : this.targetData= this.contractDataService.getCachedStepTargetData(this.paymentStep) as PaymentTransactionModel_Opt 
      this.paymentTitleStatus = 'TRANSACTION_' + this.statusConstructor(this.targetData?.payment_status||'') 

        let fullParties = this.contractParties.map(el=>{
        return {
          name:el.project.name,
          guid:el.project.guid,
          subtype:el.project.subtype==='MEMBER'? 'MEMBER' : 'PROJECT' }
      }) 
        let payerName = fullParties.find(el=>el.guid === paymentInfo.payer_guid)?.name
        let recipientName = fullParties.find(el=>el.guid === paymentInfo.recipient_guid)?.name
        let tempStatus = this.translateService.instant('FINANCE.PAYMENT.PAY_STATUS.' + this.statusConstructor(this.targetData?.payment_status||'')) + ' (' + this.targetData.payment_status + ')' 
        this.paymentDetails = [
            {key:'payer',value:this.titleCasePipe.transform(payerName)}, 
            {key:'recipient',value:this.titleCasePipe.transform(recipientName)},
            {key:'status',value:tempStatus},
            {key:'created_at',value: this.datePipe.transform(this.targetData?.created_at,'dd.MM.yyyy')||''}, 
            {key:'guid',value:this.paymentGuid},
            {key:'updated_at',value:this.datePipe.transform(this.targetData?.updated_at,'dd.MM.yyyy')||''} 
        ]
    }
    cancelAction() {
      this.dialogRef.close()
    }
    statusConstructor(payment_status: string): string {
        let status: string;
        switch (payment_status) {
            case 'NEW':
                status = 'INITIATED';
                return status;

            case 'PROMISED':
                status = 'WORK';
                return status;

            case 'APPROVED':
                status = 'APPROVED';
                return status;

            case 'EXECUTION':
                status = 'WORK';
                return status;

            case 'SUCCESS':
                status = 'SUCCESS';
                return status;
            default:
                status = 'CANCELED';
                return status;
        }
    }

}
